import { twMerge } from 'tailwind-merge';

import { IPaymentTemplate } from '@/entities/payment/lib/serialize';

import { Button } from '@/shared/ui';

import { ComplianceFormSubmit, ComplianceModal } from './ComplianceModal';

interface UploadBarProps {
  payment?: IPaymentTemplate;
  title: string;
  subtitle: string;
  buttonText: string;
  onFormSubmit: ComplianceFormSubmit;
  className?: string;
  modalTitle?: string;
  modalSubtitle?: string;
  isSubmitting?: boolean;
  requestIdFallback?: string;
  isPaymentLoading?: boolean;
  autoOpen?: boolean;
  onAutoOpenDismiss?: () => void;
}

export const UploadBar: React.FC<UploadBarProps> = ({
  payment,
  isPaymentLoading,
  title,
  subtitle,
  buttonText,
  onFormSubmit,
  className,
  modalTitle,
  modalSubtitle,
  isSubmitting = false,
  requestIdFallback,
  autoOpen = false,
  onAutoOpenDismiss,
}) => {
  return (
    <div
      className={twMerge(
        'mx-auto flex w-full items-center justify-between rounded-[24px] bg-base-500 p-5 md:max-w-[630px]',
        className,
      )}
    >
      <div className="flex items-start gap-3">
        <div className="w-full flex-1">
          <p className="pr-1 headline-4 typography-14m">{title}</p>
          <p className="mt-1 text-base-100 typography-14r">{subtitle}</p>
        </div>
      </div>
      {(!payment || isPaymentLoading) && (
        <Button
          variant="d-secondary"
          size="md"
          className="w-[69px]"
          loading
        >
          {buttonText}
        </Button>
      )}
      {!!payment && (
        <ComplianceModal
          payment={payment}
          title={modalTitle ?? title}
          subtitle={modalSubtitle ?? subtitle}
          onFormSubmit={onFormSubmit}
          isSubmitting={isSubmitting}
          requestIdFallback={requestIdFallback}
          autoOpen={autoOpen}
          onAutoOpenDismiss={onAutoOpenDismiss}
        >
          <Button variant="d-secondary" size="md" className="w-[69px]">
            {buttonText}
          </Button>
        </ComplianceModal>
      )}
    </div>
  );
};
